<template>
  <div>
    <transition-group name="list-complete" tag="div">
      <div
        class="list-complete-item"
        v-for="(action_plan_origin, index) in action_plan_origins"
        :key="`${action_plan_origin.datetime}-${index}`"
      >
        <div class="d-flex justify-space-between">
          <v-autocomplete
            :items="origins"
            class="px-2"
            item-text="name"
            item-value="id"
            :rules="[
              (v) => !!v || generateMessage('actionplans.create.noorigin'),
            ]"
            v-model="action_plan_origin.origin_subtype_id"
            :label="generateMessage('actionplans.create.origin')"
            required
            outlined
            dense
          ></v-autocomplete>
          <v-text-field
            label="Date origine"
            v-model="action_plan_origin.datetime"
            type="datetime-local"
            dense
            outlined
            class="px-2"
            min="2010-06-07T00:00"
          ></v-text-field>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click.stop="handleRemoveOrigin(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>
              {{ generateMessage('actionplans.create.origins.remove') }}
            </span>
          </v-tooltip>
        </div>
      </div>
    </transition-group>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon @click.stop="handleAddOrigin">
          <v-icon>add_box</v-icon>
        </v-btn>
      </template>
      <span>
        {{ generateMessage('actionplans.create.origins.add') }}
      </span>
    </v-tooltip>
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import { getCurrentLocalDateTime } from '@/business/utils/dates';

export default {
  name: 'custom-origin-selector',
  props: {
    action_plan_origins: { type: Array, required: true },
  },
  computed: {
    ...mapGetters({
      origins: 'actionplans/origins/items',
    }),
  },
  methods: {
    generateMessage,
    getCurrentLocalDateTime,
    handleAddOrigin() {
      this.$emit('update:action_plan_origins', [
        ...this.action_plan_origins,
        {
          origin_subtype_id: null,
          datetime: this.getCurrentLocalDateTime(),
        },
      ]);
    },
    handleRemoveOrigin(index) {
      this.$emit(
        'update:action_plan_origins',
        this.action_plan_origins.filter((el, ind) => ind !== index)
      );
    },
  },
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
